export default "__VITE_PUBLIC_ASSET__40dd133a__"